import DicomStorePage from "@/pages/dicomStore/DicomStorePage";
import { createFileRoute } from "@tanstack/react-router";

/**
 * DICOM Store route definition
 */

export const Route = createFileRoute("/dicom-store")({
  component: DicomStorePage,
});
